import React, { ReactElement, useState } from 'react';
import { MoreOutlined } from '@ant-design/icons';
import { Button } from '../antd/Button/Button';
import { Dropdown } from '../antd/Dropdown/Dropdown';

type TPropsTypes = {
  record: any;
  onClickItemAction: any;
  menuItems: any;
}

const TableActionColumnDropdown = (props: TPropsTypes): ReactElement => {
  const {
    record,
    onClickItemAction,
    menuItems,
  } = props;

  const [isLoading, setIsLoading] = useState(false);

  return (
    <Dropdown
      menu={{
        items: menuItems,
        onClick: async ({ key }): Promise<void> => {
          try {
            setIsLoading(true);

            await onClickItemAction({ record, actionKey: key });

            setIsLoading(false);
          } catch (error) {
            console.error(error);
          }
        },
      }}
      placement="topRight"
      trigger={['click']}
    >
      <Button
        loading={isLoading}
        type="text"
        icon={<MoreOutlined />}
      />
    </Dropdown>
  );
};

export default TableActionColumnDropdown;
